import { render, staticRenderFns } from "./otherPay.vue?vue&type=template&id=dd444ce0&scoped=true&"
import script from "./otherPay.vue?vue&type=script&lang=js&"
export * from "./otherPay.vue?vue&type=script&lang=js&"
import style0 from "./otherPay.vue?vue&type=style&index=0&lang=css&"
import style1 from "./otherPay.vue?vue&type=style&index=1&id=dd444ce0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd444ce0",
  null
  
)

export default component.exports